import type { LabelPair } from '@app/utils/labels';

interface LabelPairsEditorProps {
  pairs: LabelPair[];
  onChange: (pairs: LabelPair[]) => void;
  disabled?: boolean;
  emptyHint?: string;
}

const LabelPairsEditor = ({ pairs, onChange, disabled = false, emptyHint }: LabelPairsEditorProps) => {
  const updatePair = (index: number, field: keyof LabelPair, value: string) => {
    onChange(pairs.map((pair, pairIndex) => (pairIndex === index ? { ...pair, [field]: value } : pair)));
  };

  const handleAdd = () => {
    onChange([...pairs, { key: '', value: '' }]);
  };

  const handleRemove = (index: number) => {
    onChange(pairs.filter((_, pairIndex) => pairIndex !== index));
  };

  return (
    <div className="labels-editor">
      {pairs.length === 0 && emptyHint && <p className="helper-text">{emptyHint}</p>}
      {pairs.map((pair, index) => (
        <div key={`label-${index}`} className="label-row">
          <input
            className="input"
            placeholder="key"
            value={pair.key}
            onChange={(event) => updatePair(index, 'key', event.target.value)}
            disabled={disabled}
          />
          <input
            className="input"
            placeholder="value"
            value={pair.value}
            onChange={(event) => updatePair(index, 'value', event.target.value)}
            disabled={disabled}
          />
          <button type="button" className="link-button" onClick={() => handleRemove(index)} disabled={disabled}>
            Remove
          </button>
        </div>
      ))}
      <button type="button" className="link-button" onClick={handleAdd} disabled={disabled}>
        + Add label
      </button>
    </div>
  );
};

export default LabelPairsEditor;
